import { Injectable } from '@angular/core';

@Injectable()
export class DateUtility {

  monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];



  constructor(

  ) {

  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('/');
  }
  formatDate1(date) {
    var d = new Date(date);
    d.setDate(d.getDate() +1);
      let month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('/');
  }

  formatDateMDY(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [ month, day, year].join('/');
  }

  //Convert date to { year: '', month: '', day: '' } format
  //Use Server date format and client format date (APP_DATE_FORMAT) constant
  convertDateFromServer(value) {
    if (value) {
      let dateObj: any = {};
      const parts = value.trim().split('/');

      //Parse dates depending on the DATEFORMAT constant
      dateObj.year = parseInt(parts[0]);
      dateObj.month = parseInt(parts[1]);
      dateObj.day = parseInt(parts[2]);

      return dateObj;
    }
  }

 convertDateFromServerForExcelPDF(value) {
    if (value) {
      let dateObj: any;
      const parts = value.trim().split('/');

      //Parse dates depending on the DATEFORMAT constant
      //dateObj.year = parseInt(parts[0]);
      //dateObj.month = parseInt(parts[1]);
      //dateObj.day = parseInt(parts[2]);
      dateObj = parts[1]+"/"+parts[2]+"/"+parts[0]
      return dateObj;
    }
  }

  //Use Server date format and client format date (APP_DATE_FORMAT) constant
  convertDateForServer(obj) {
    if (obj) {
      let day = obj.day;
      let month = obj.month;
      let year = obj.year;

      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }

      //Parse dates depending on the DATEFORMAT constant
      return year + '/' + month + '/' + day;
    }
  }

  convertObjectDateForServer(date: Date) {
    if(date){
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let year = date.getFullYear();

      let stDay;
      let stMonth;

      if (day < 10) {
        stDay = '0' + day;
      }else{
        stDay = day;
      }
      if (month < 10) {
        stMonth = '0' + month;
      }else {
        stMonth = month;
      }

      return year + '/' + stMonth + '/' + stDay;

    }
  }

  getSystemDateFromModel() {
    const sysDate = new Date();
    return {
      year: sysDate.getFullYear(),
      month: sysDate.getMonth() + 1,
      day: sysDate.getDate()
    };
  }

  getFormattedSystemDateFromModel() {

    const today = new Date();
    const dd = today.getDate();
    const mm = today.getMonth() + 1; //January is 0!
    let ddString;
    let mmString;
    const yyyy = today.getFullYear();

    if (dd < 10) {
      ddString = '0' + dd
    } else {
      ddString = '' + dd
    }

    if (mm < 10) {
      mmString = '0' + mm
    } else {
      mmString = '' + mm
    }
    return mmString + '/' + ddString + '/' + yyyy

  }

  getFormattedSystemDateFromModelForServer() {

    const today = new Date();
    const dd = today.getDate();
    const mm = today.getMonth() + 1; //January is 0!
    let ddString;
    let mmString;
    const yyyy = today.getFullYear();

    if (dd < 10) {
      ddString = '0' + dd
    } else {
      ddString = '' + dd
    }

    if (mm < 10) {
      mmString = '0' + mm
    } else {
      mmString = '' + mm
    }
    return yyyy + '/' + mmString + '/' + ddString

  }

  getDueDateFromSystemForServer(days) {

    const today = new Date();
    let dd = today.getDate();
    const mm = today.getMonth() + 1; //January is 0!
    let ddString;
    let mmString;
    const yyyy = today.getFullYear();
    dd=dd+days;
    if (dd < 10) {
      ddString = '0' + dd
    } else {
      ddString = '' + dd
    }

    if (mm < 10) {
      mmString = '0' + mm
    } else {
      mmString = '' + mm
    }
    return yyyy + '/' + mmString + '/' + ddString

  }

   //Use Server date format and client format date (APP_DATE_FORMAT) constant
   convertFormattedDateForServer(value) {
    if (value) {
      const dateObj: any = {};
      const parts = value.trim().split('/');
      dateObj.month = parts[0];
      dateObj.day = parts[1];
      dateObj.year = parts[2];
      //Parse dates depending on the DATEFORMAT constant
      return dateObj.year + '/' + dateObj.month + '/' + dateObj.day;
    }
  }

  convertFormattedDateFromServer(value) {
    if (value) {
      const dateObj: any = {};
      const parts = value.trim().split('/');

      //Parse dates depending on the DATEFORMAT constant
      dateObj.year = parts[0];
      dateObj.month = parts[1];
      dateObj.day = parts[2];
      return dateObj.month + '/' + dateObj.day + '/' + dateObj.year

    }
  }


  /**
 * Compares two Date objects and returns e number value that represents
 * the result:
 * 0 if the two dates are equal.
 * 1 if the first date is greater than second.
 * -1 if the first date is less than second.
 * @param date1 First date object to compare.
 * @param date2 Second date object to compare.
 */
compareDate(date1: Date, date2: Date): number
{
  // With Date object we can compare dates them using the >, <, <= or >=.
  // The ==, !=, ===, and !== operators require to use date.getTime(),
  // so we need to create a new instance of Date with 'new Date()'
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  // Check if the dates are equal
  const same = d1.getTime() === d2.getTime();
  if (same)
  {
    return 0;
  }

  // Check if the first is greater than second
  if (d1 > d2)
  {
    return 1;
  }

  // Check if the first is less than second
  if (d1 < d2)
  {
    return -1;
  }
}

getDaysBetweenDates(date1: Date, date2: Date):number
{
  const one_day=1000*60*60*24;
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  const difference_ms = d2.getTime() -d1.getTime();

  // Convert back to days and return
  return Math.round(difference_ms/one_day);
}

addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

getTodaysDateWithoutTime()
{
  const today=new Date();
  today.setHours(0,0,0,0);
  return today;
}
  convertDateFromServerForreports(value) {
    if (value) {
      let dateObj: any = {};
      const parts = value.trim().split('/');

      //Parse dates depending on the DATEFORMAT constant
      dateObj.year = parseInt(parts[0]);
      dateObj.month = parseInt(parts[1]);
      dateObj.day = parseInt(parts[2]);

      return dateObj;
    }
  }

  // Return the Month name for the give Month in number
  getMonthName(month: number) {
    return this.monthNames[month];
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/Utility/DateUtility.ts